import React from "react";
import { View } from "react-native";
import { LinearGradient } from "expo-linear-gradient";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";
import { AppColors } from "../../utility/AppColors";
import { s } from "react-native-size-matters";

const ChooseAvatarSkeleton = () => {
  const deviceSize = useDeviceSize();
  const isMobile = deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;
  const avatarsPerRow = isMobile ? 3 : 6;
  const numberOfRows = isMobile ? 5 : 3;

  return (
    <View
      style={{
        paddingHorizontal:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? s(8)
            : s(8),
        paddingTop:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? s(8)
            : s(8),
        flex: 1,
      }}
    >
      {/* Header with Title and Logo */}
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 8,
        }}
      >
        <Skeletons
          height={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 30
              : 40
          }
          width={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "150px"
              : "200px"
          }
          style={{ borderRadius: 6 }}
        />
        <Skeletons
          height={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? 54
              : 99
          }
          width={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "100px"
              : "183px"
          }
          style={{ borderRadius: 6 }}
        />
      </View>

      {/* Main Content Area */}
      <View
        style={{
          display: "flex",
          marginBottom:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 8
              : 0,
          marginTop: 8,
          flexDirection:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? "column-reverse"
              : "row",
          flex: 1,
        }}
      >
        {/* Avatar Grid Section */}
        <LinearGradient
          colors={["#111827", "#000000"]}
          start={[0, 0]}
          end={[0, 1]}
          style={{
            borderRadius: 12,
            padding: 8,
            flex:
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? 1
                : 0.72,
          }}
        >
          <View
            style={{
              paddingHorizontal: 12,
              paddingVertical: 12,
            }}
          >
            {Array(numberOfRows)
              .fill(0)
              .map((_, rowIndex) => (
                <View
                  key={rowIndex}
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "100%",
                    marginBottom: 12,
                  }}
                >
                  {Array(avatarsPerRow)
                    .fill(0)
                    .map((_, colIndex) => (
                      <Skeletons
                        key={colIndex}
                        height={138}
                        width={isMobile ? "108px" : "128px"}
                        style={{ borderRadius: 8 }}
                      />
                    ))}
                </View>
              ))}
          </View>
        </LinearGradient>

        {/* Separator */}
        {deviceSize === DEVICE_SIZES.SM ||
        deviceSize === DEVICE_SIZES.XS ? null : (
          <View
            style={{
              width: 1,
              backgroundColor: AppColors.white,
              marginHorizontal: 8,
            }}
          />
        )}

        {/* Avatar Look Section */}
        {deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS ? (
          <View style={{ padding: 5, marginTop: 0 }}>
            <Skeletons
              height={20}
              width={"120px"}
              style={{
                borderRadius: 6,
                marginBottom: deviceSize === DEVICE_SIZES.XS ? 12 : 18
              }}
            />
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-around",
                gap: 8,
              }}
            >
              {/* Head */}
              <View
                style={{
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <Skeletons height={100} width={"100px"} style={{ borderRadius: 8 }} />
                <Skeletons height={18} width={"60px"} style={{ borderRadius: 4 }} />
              </View>
              {/* Upper Body */}
              <View
                style={{
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <Skeletons height={100} width={"100px"} style={{ borderRadius: 8 }} />
                <Skeletons height={18} width={"90px"} style={{ borderRadius: 4 }} />
              </View>
              {/* Full Body */}
              <View
                style={{
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <Skeletons height={100} width={"100px"} style={{ borderRadius: 8 }} />
                <Skeletons height={18} width={"80px"} style={{ borderRadius: 4 }} />
              </View>
            </View>
          </View>
        ) : (
          <View
            style={{
              flex: 0.28,
              padding: 16,
            }}
          >
            <Skeletons
              height={20}
              width={"120px"}
              style={{ borderRadius: 6, marginBottom: 16 }}
            />
            {/* Head */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
                marginBottom: 20,
              }}
            >
              <Skeletons height={140} width={"110px"} style={{ borderRadius: 8 }} />
              <Skeletons height={18} width={"60px"} style={{ borderRadius: 4 }} />
            </View>
            {/* Upper Body */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
                marginBottom: 20,
              }}
            >
              <Skeletons height={140} width={"110px"} style={{ borderRadius: 8 }} />
              <Skeletons height={18} width={"90px"} style={{ borderRadius: 4 }} />
            </View>
            {/* Full Body */}
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
              }}
            >
              <Skeletons height={140} width={"110px"} style={{ borderRadius: 8 }} />
              <Skeletons height={18} width={"80px"} style={{ borderRadius: 4 }} />
            </View>
          </View>
        )}
      </View>

      {/* Button Section */}
      <LinearGradient
        colors={["#111827", "#000000"]}
        start={[0, 0]}
        end={[0, 1]}
        style={{
          marginTop: s(8),
          marginBottom:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 0
              : s(8),
          flexDirection: "row",
          gap: s(10),
          justifyContent: "space-between",
          alignItems: "center",
          position: "absolute",
          bottom: 0,
          left:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 5
              : 18,
          right:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 5
              : 18,
          width:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? "95%"
              : null,
          padding: 18,
          borderRadius: 12,
        }}
      >
        <Skeletons
          height={40}
          width={"100px"}
          style={{ borderRadius: 6 }}
        />
        <Skeletons
          height={40}
          width={"158px"}
          style={{ borderRadius: 6 }}
        />
      </LinearGradient>
    </View>
  );
};

export default ChooseAvatarSkeleton;
